export default "__VITE_ASSET__DkaT2gU5__"